import filterConstants from '../constants';

const reportsProgressMonth = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.reportsProgressMonth,
  properties: {
    [filterConstants.PROPERTY.gantt_id]: '',
    [filterConstants.PROPERTY.rangeDate]: '',
  },
});

export default reportsProgressMonth;
